const socialMedia = {
    instagram: 'https://instagram.com',
    twitter: 'https://twitter.com',
    facebook: '',
    email: ''
};

export default socialMedia;